import { createIntegerRollupCompiler } from './integer-layer-rollup';
import { statusProjectionDependencies } from './status-attack-budget';
import { createFormulaReadContext } from './formula-read-context';
import { applyStatusRootFields, compileStatusRootFields } from './status-root-residue';

type Row = Record<string, unknown>;
const LIGHT = 'bright_light_dim_light';

/** An applied inventory status has saved rows but no creature computed delta.
 * Finish its light before publishing the normal encounter projection. The same
 * integer/source rollup handles add, stack and last-source removal idempotently. */
export function projectInventoryStatusLight(before: Row, after: Row, definition: (id: string) => Row | null): Row {
    const deps = statusProjectionDependencies(after, definition);
    const projected = createIntegerRollupCompiler({ ...deps, metadata: { ...deps.metadata, integerLayers: [LIGHT] } }).compile(after) as Row;
    const read = createFormulaReadContext(deps);
    const roots = compileStatusRootFields(before, after, { definition, entries: (row, key) => Object.values(read.layerEntries(row, key)),
        value: read.layerValue, active: () => true, buckets: () => ({}), gearLayers: [], quantityIds: [], gearCounted: () => false });
    applyStatusRootFields(projected, Object.fromEntries(Object.entries(roots).filter(([key]) => key === 'magical_light')));
    return projected;
}
